import { c as _c } from "react/compiler-runtime";
import { getOrigin } from "@website/utils/channel/get-origin";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { ReserveRateFooter } from "@website/widget/reserve-rate/reserve-rate-footer";
import { ReserveRateHeader } from "@website/widget/reserve-rate/reserve-rate-header";
import { ReserveProgressBar } from "@website/widget/reserve-rate/reserve-rate-progress-bar";
import { ReserveRateEnum, ReserveRatePropertiesTypes, ReserveRateTypes, ReserveVillaRateEnum } from "@website/widget/reserve-rate/reserve-rate.types";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
export const ReserveRate = properties => {
  const $ = _c(40);
  const {
    rate,
    rateCount,
    offerCount,
    offerMessage,
    rateDetail,
    showTitle: t0,
    size: t1,
    hasBackground: t2,
    hotelType,
    sectionTitle,
    pageTitle,
    pageDescription,
    aiSummary,
    showFooter: t3
  } = properties;
  const showTitle = t0 === undefined ? true : t0;
  const size = t1 === undefined ? "large" : t1;
  const hasBackground = t2 === undefined ? true : t2;
  const showFooter = t3 === undefined ? true : t3;
  const router = useRouter();
  if (!rateCount || !rate || Number(rate) < 1) {
    return null;
  }
  const t4 = `${size === "medium" ? "bg-dim-background h-fit min-w-[324px] rounded-lg p-4 xl:bg-white" : "min-w-[312px]"} ${aiSummary ? "" : "!w-full"}`;
  let t5;
  if ($[0] !== offerCount || $[1] !== pageDescription || $[2] !== pageTitle || $[3] !== rate || $[4] !== rateCount) {
    t5 = pageTitle && pageDescription && <script dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "Review",
        author: {
          "@type": "Person",
          name: replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E")
        },
        itemReviewed: {
          "@type": "Product",
          name: toString(pageTitle),
          image: `${getOrigin()}/logo.png`,
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: toString(rate || 1),
            ratingCount: toString(rateCount || 1),
            reviewCount: toString(offerCount || 1),
            bestRating: "5",
            worstRating: "1"
          },
          description: toString(pageDescription),
          brand: replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E")
        },
        reviewRating: {
          "@type": "Rating",
          ratingValue: toString(rate || 1),
          bestRating: "5",
          worstRating: "1"
        }
      })
    }} type="application/ld+json" />;
    $[0] = offerCount;
    $[1] = pageDescription;
    $[2] = pageTitle;
    $[3] = rate;
    $[4] = rateCount;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== hotelType || $[7] !== sectionTitle || $[8] !== showTitle) {
    t6 = showTitle && <h2 className="text-subtitle-1 md:text-headline-6 mb-4">{sectionTitle ?? replaceSnappTripBasedOnChannel(`امتیاز ${hotelType} از دید کاربران اسنپ‌تریپ`)}</h2>;
    $[6] = hotelType;
    $[7] = sectionTitle;
    $[8] = showTitle;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `flex min-w-[218px] flex-col gap-4 rounded-[8px] md:w-full lg:max-w-[1200px] xl:rounded-[8px] ${size === "large" ? "xl:max-w-[1200px] xl:rounded-[8px] xl:px-10 xl:py-8" : ""} ${hasBackground ? "bg-dim-background p-6 xl:px-10 xl:py-8" : ""}`;
  const t8 = `flex flex-col gap-4 ${size === "large" ? "xl:flex-row xl:items-center xl:gap-[40px]" : ""}`;
  let t9;
  if ($[10] !== rate || $[11] !== rateCount || $[12] !== size) {
    t9 = <ReserveRateHeader properties={{
      rate,
      rateCount,
      size
    }} />;
    $[10] = rate;
    $[11] = rateCount;
    $[12] = size;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = `bg-outline-thin hidden h-[72px] w-px ${size === "large" ? "xl:block" : ""}`;
  let t11;
  if ($[14] !== t10) {
    t11 = <div className={t10} />;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = `grid w-full gap-x-[40px] gap-y-4 lg:gap-y-1 ${size === "large" ? "xl:grid-cols-2" : ""}`;
  let t13;
  if ($[16] !== rateDetail || $[17] !== router) {
    t13 = Object.keys(rateDetail)?.map(key => {
      if (!rateDetail[key as ReserveRateTypes]) {
        return null;
      }
      return <div className="flex flex-row items-start gap-4 lg:flex-col lg:gap-1" key={key}><div className="text-caption md:text-body-2 w-[152px] md:w-[178px]">{process.env.NEXT_PUBLIC_APP_NAME === "villa" ? ReserveVillaRateEnum[key as ReserveRateTypes] : ReserveRateEnum[key as ReserveRateTypes]}</div><div className="flex w-full flex-row items-center gap-1"><ReserveProgressBar properties={{
            limit: 5,
            progress: Number(rateDetail[key as ReserveRateTypes])
          }} /><div className="text-caption md:text-body-2">{numberConvert(rateDetail[key as ReserveRateTypes], {
              locale: router.locale
            })}</div></div></div>;
    });
    $[16] = rateDetail;
    $[17] = router;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12 || $[20] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t11 || $[23] !== t14 || $[24] !== t8 || $[25] !== t9) {
    t15 = <div className={t8}>{t9}{t11}{t14}</div>;
    $[22] = t11;
    $[23] = t14;
    $[24] = t8;
    $[25] = t9;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== t7) {
    t16 = <div className={t7}>{t15}</div>;
    $[27] = t15;
    $[28] = t7;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== offerCount || $[31] !== offerMessage || $[32] !== showFooter) {
    t17 = Boolean(offerCount) && showFooter && <ReserveRateFooter properties={{
      offerCount,
      offerMessage
    }} />;
    $[30] = offerCount;
    $[31] = offerMessage;
    $[32] = showFooter;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6) {
    t18 = <div className={t4}>{t5}{t6}{t16}{t17}</div>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};